import {
  cloneElement,
  type DetailedHTMLProps,
  type LiHTMLAttributes,
  type ReactElement,
} from 'react';
import { twMerge } from 'tailwind-merge';
import ListItemText from '@mui/material/ListItemText';
import { classes } from './utils';

export interface MenuItemProps extends DetailedHTMLProps<
  LiHTMLAttributes<HTMLLIElement>,
  HTMLLIElement
> {
  destructive?: boolean;
  label: string;
  icon?: ReactElement;
}

export default function MenuItem({
  destructive = false,
  className = '',
  icon,
  label,
  ...props
}: MenuItemProps) {
  return (
    <li
      className={twMerge(
        classes.listItem,
        destructive && classes.destructive,
        className
      )}
      {...props}>
      {icon &&
        cloneElement(icon, {
          className: twMerge(
            classes.icon,
            destructive && classes.destructiveIcon,
            icon.props.className
          ),
        })}
      <ListItemText
        primaryTypographyProps={{ color: 'inherit', className: classes.label }}>
        {label}
      </ListItemText>
    </li>
  );
}
